import React from 'react';

import { bool, func, string } from 'prop-types';
import {
  Button,
  ButtonArea,
  Container,
  Dialog,
  Header,
  Text,
} from './styles';

const InstructionsModal = (props) => {
  const {
    content,
    label,
    onClose,
    show,
    title,
  } = props;

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog>
        <Header as="h3">{title}</Header>

        <Text>{content}</Text>

        <ButtonArea>
          <Button onClick={onClose}>
            {label}
          </Button>
        </ButtonArea>
      </Dialog>
    </Container>
  );
};

InstructionsModal.propTypes = {
  content: string.isRequired,
  label: string.isRequired,
  onClose: func.isRequired,
  show: bool,
  title: string.isRequired,
};

InstructionsModal.defaultProps = {
  show: false,
};

export default InstructionsModal;
